import 'core-js/stable';
// add lazy-load supported
import LazyLoad from "vanilla-lazyload";
import lazyLoad from "./components/lazyLoad";

document.addEventListener( 'DOMContentLoaded', function () {

	lazyLoad();

	let myLazyLoad = new LazyLoad();

	let burger = document.querySelector( '.burger' );
	let body = document.querySelector( 'body' );
	let menu = document.querySelector( '.header__nav-mobile ul' );
	let headerMobile = document.querySelector( '.header__container-mobile' );

	let isMenuOpen = false;
	if ( burger ) {
		burger.addEventListener( 'click', function () {
			burger.classList.toggle( 'close' );
			isMenuOpen = !isMenuOpen;
			if ( isMenuOpen ) {
				headerMobile.style.height = '100vh';
				menu.style.display = 'flex';
				body.style.overflow = 'hidden';
			} else {
				headerMobile.style.height = '0';
				menu.style.display = 'none';
				body.style.overflow = 'scroll';
			}
		} );
	}
} );